export const CREDIT_CARD = 'CREDIT_CARD';
export const AMAZON_PAY = 'AMAZON_PAY';
export const AFTER_PAY = 'AFTER_PAY';
export const PAYPAL = 'PAYPAL';
export const NEW_CREDIT_CARD = 'NEW_CREDIT_CARD';
export const THIRD_PARTY_PAYMENT_METHODS = [AMAZON_PAY, AFTER_PAY, PAYPAL];
export const CREDIT_CARD_PAYMENT_METHODS = [CREDIT_CARD, NEW_CREDIT_CARD];
